import type { AccessControlProvider } from "@refinedev/core";
import { USER_KEY } from "@/lib/constants";
import type { Role } from "@/lib/types";
import { MOCK_ENABLED } from "@/mock/flag";

/**
 * accessControlProvider — defesa-em-profundidade no cliente.
 *
 * A fronteira real é o RolesGuard da API (/admin/* exige role=admin). Aqui só
 * garantimos que a UI inteira fica disponível apenas para admins; qualquer
 * outra role nunca chega a esta tela (o authProvider já barra no login).
 *
 * TODO(Fase 3): granularidade por ação/recurso (ex.: só super-admin pode
 *   impersonate/moderar/excluir entries). Hoje admin = acesso total.
 */
export const accessControlProvider: AccessControlProvider = {
  can: async () => {
    if (MOCK_ENABLED) return { can: true };
    const role = getStoredRole();
    return { can: role === "admin" };
  },
  options: {
    buttons: {
      enableAccessControl: true,
      hideIfUnauthorized: true,
    },
  },
};

function getStoredRole(): Role | null {
  const raw = localStorage.getItem(USER_KEY);
  if (!raw) return null;
  try {
    return (JSON.parse(raw) as { role?: Role }).role ?? null;
  } catch {
    return null;
  }
}
